/* tslint:disable */
/* eslint-disable */
/**
 * User service API
 * Service for user management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OnboardResponse
 */
export interface OnboardResponse {
    /**
     * User Id
     * @type {string}
     * @memberof OnboardResponse
     */
    userId?: string;
}

/**
 * Check if a given object implements the OnboardResponse interface.
 */
export function instanceOfOnboardResponse(value: object): boolean {
    return true;
}

export function OnboardResponseFromJSON(json: any): OnboardResponse {
    return OnboardResponseFromJSONTyped(json, false);
}

export function OnboardResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OnboardResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
    };
}

export function OnboardResponseToJSON(value?: OnboardResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'userId': value['userId'],
    };
}

